import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const ItemWrapper = styled.li`
    background: white;
    cursor: pointer;
    padding: 1em;
    padding-bottom: 2em;
`

class Item extends React.Component {
    static propTypes = {
        children: PropTypes.element,
        onSelect: PropTypes.func,
        onUnselect: PropTypes.func,
    }

    static defaultProps = {
        isSelected: false,
        onSelect: () => {},
        onUnselect: () => {},
    }

    constructor (props) {
        super(props)

        this.onMouseEnter = this.onMouseEnter.bind(this)
        this.onMouseLeave = this.onMouseLeave.bind(this)
    }

    onMouseEnter () {
        this.props.onSelect()
    }

    onMouseLeave () {
        this.props.onUnselect()
    }

    render () {
        return (
            <ItemWrapper
              onMouseEnter={this.onMouseEnter}
              onMouseLeave={this.onMouseLeave}
            >
                {this.props.children}
            </ItemWrapper>
        )
    }
}

export default Item
